module.exports = __webpack_public_path__ + "static/media/algorithm_1.0e8c8d68.svg";